import { createSlice } from "@reduxjs/toolkit";
import { LoadingState } from "@repo/app-types/client/client";
import { fetchInsightsAsync } from "../../features/insights/insightsSlice.js";
import {
  fetchFocusedInterview,
  fetchNonEmptyInterviewsForProject,
} from "../../features/interviews/interviewsSlice.js";
import { accountsAdapter } from "./accountsState.js";

const initialState = accountsAdapter.getInitialState<{
  status: LoadingState;
  error: string | null;
}>({
  status: LoadingState.LOADED,
  error: null,
});

const accountsSlice = createSlice({
  name: "accounts",
  initialState,
  reducers: {
    accountsAdded: accountsAdapter.addMany,
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchNonEmptyInterviewsForProject.fulfilled,
      (state, action) => {
        state.status = LoadingState.LOADED;
        accountsAdapter.addMany(state, action.payload.accounts);
      },
    );
    builder.addCase(fetchFocusedInterview.fulfilled, (state, action) => {
      if (action.payload.account)
        accountsAdapter.upsertOne(state, action.payload.account);
    });
    builder.addCase(fetchInsightsAsync.fulfilled, (state, action) => {
      accountsAdapter.addMany(state, action.payload.accounts);
    });
  },
});

export const { accountsAdded } = accountsSlice.actions;
export default accountsSlice.reducer;
